import LoadingBar, { LoadingBarRef } from 'react-top-loading-bar';
import { useNavigation } from 'react-router';
import React, { useEffect, useRef } from 'react';

export default function TopLoadingBar() {
    const navigation = useNavigation();
    const ref = useRef<LoadingBarRef>(null);

    useEffect(() => {
        if (navigation.state === 'loading' || navigation.state === 'submitting') {
            ref.current?.continuousStart();
        } else {
            ref.current?.complete();
        }
    }, [navigation.state]);

    return <LoadingBar
        ref={ref}
        color="#0c4a6e"
        height={3}
        shadow={true}
        waitingTime={400}
    />;
}
